import { Cell, Layout } from '@wix/design-system'
import React, { FC, memo, useCallback } from 'react'

import type { Content } from '../Content'
import { Radio } from '../Radio'

type Option = Content['role']['options'][number]

type RoleSelectProps = {
  options: Option[]
  value: string
  onSelect?: (value: string) => void
}

export const RoleSelect: FC<RoleSelectProps> = memo(({ options, value, onSelect }) => {
  const handleClick = useCallback((value: string) => onSelect?.(value), [onSelect])

  return (
    <Layout gap="6px" rowHeight="1fr">
      {options.map(option => (
        <Cell span={4} key={option.optionKey}>
          <Radio
            checked={option.optionKey === value}
            value={option.optionKey}
            label={option.title}
            onClick={() => handleClick(option.optionKey)}
          />
        </Cell>
      ))}
    </Layout>
  )
})
